import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.function.name.js";
/**
 * Check if a panel can be removed from a q-splitter.
 *
 * @param state
 * @returns {function(...[*]=)}
 */
export function isRemovable(state) {
  return function (side) {
    if (side === 'leftA' || side === 'leftB') {
      return state.panelSides.leftA !== null && state.panelSides.leftB !== null;
    }
    return state.panelSides.rightA !== null && state.panelSides.rightB !== null;
  };
}
export function panelCombination(state) {
  var panels = [];
  var sides = state.panelSides;
  sides.leftA && sides.leftA.slug && panels.push(sides.leftA.slug);
  sides.leftB && sides.leftB.slug && panels.push(sides.leftB.slug);
  sides.rightA && sides.rightA.slug && panels.push(sides.rightA.slug);
  sides.rightB && sides.rightB.slug && panels.push(sides.rightB.slug);
  return panels;
}
export function openFloatPanel(state) {
  return state.openFloatPanel;
}
export function floatPanel(state) {
  return state.floatPanel;
}
export function floatPanelTitle(state) {
  return state.floatPanelTitle;
}
export function selectedQuery(state) {
  return state.selectedQuery;
}
export function queryNameDivided(state) {
  return state.selectedQuery && state.selectedQuery.name.split(' ');
}
export function panelSides(state) {
  return state.panelSides;
}